import getLoyaltyPurchasePointsItems from 'checkout/selectors/view/items/getLoyaltyPurchasePointsItems'
import { isLoyaltyPurchasePointsItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'
import type { LoyaltyPurchasePointsPurchaseSnapshot } from 'checkout/lib/utils/misc/steps'

export const isStandaloneLoyaltyPurchasePoints = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => !!items.length && items.every(isLoyaltyPurchasePointsItem),
)

export const isLoyaltyPurchasePointsInCart = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => items.some(isLoyaltyPurchasePointsItem),
)

export const getLoyaltyPurchasePointsPurchaseSnapshot = createSelector(
  isStandaloneLoyaltyPurchasePoints,
  getLoyaltyPurchasePointsItems,
  (isStandalone, items): LoyaltyPurchasePointsPurchaseSnapshot | null => {
    if (!isStandalone || items.length === 0) return null
    const item = items[0]
    return { creditedPoints: item.points + item.bonusPoints }
  },
)
